import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from '@components/common/Layout';

// Page imports
import Home from '@pages/Home';
import Products from '@pages/Products';
import ProductDetail from '@pages/ProductDetail';
import Solutions from '@pages/Solutions';
import About from '@pages/About';
import Resources from '@pages/Resources';
import DemoCenter from '@pages/DemoCenter';
import Careers from '@pages/Careers';
import Internship from '@pages/Internship';
import Contact from '@pages/Contact';
import Security from '@pages/Security';
import Clients from '@pages/Clients';
import Partners from '@pages/Partners';
import FAQs from '@pages/FAQs';
import Blog from '@pages/Blog';
import CaseStudies from '@pages/CaseStudies';

// Context
import { AppProvider } from '@context/AppContext';

function App() {
  return (
    <AppProvider>
      <Layout>
        <AnimatePresence mode="wait">
          <Routes>
            {/* Main Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/solutions" element={<Solutions />} />
            <Route path="/about" element={<About />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/demo" element={<DemoCenter />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/internship" element={<Internship />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/security" element={<Security />} />
            
            {/* Company Pages */}
            <Route path="/clients" element={<Clients />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/faqs" element={<FAQs />} />
            
            {/* Content Pages */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:id" element={<Blog />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/:id" element={<CaseStudies />} />
          </Routes>
        </AnimatePresence>
      </Layout>
    </AppProvider>
  );
}

export default App;